import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dIndex from "../Foreign.Index/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const Result = x => x;
const udecodeResult = dictDecode => dictDecode1 => (
  {
    unsafeDecode: f => {
      if (!Foreign.isUndefined(f.Left)) { return Data$dEither.$Either("Left", dictDecode.unsafeDecode(f.Left)); }
      return Data$dEither.$Either("Right", dictDecode1.unsafeDecode(f.Right));
    }
  }
);
const showResult = dictShow => dictShow1 => (
  {
    show: v => {
      if (v.tag === "Left") { return "(Left " + dictShow.show(v._1) + ")"; }
      if (v.tag === "Right") { return "(Right " + dictShow1.show(v._1) + ")"; }
      $runtime.fail();
    }
  }
);
const newtypeResult = {Coercible0: () => {}};
const toEither = Unsafe$dCoerce.unsafeCoerce;
const functorResult = Data$dEither.functorEither;
const fromEither = Unsafe$dCoerce.unsafeCoerce;
const eqResult = dictEq => dictEq1 => (
  {
    eq: x => y => {
      if (x.tag === "Left") {
        if (y.tag === "Left") { return dictEq.eq(x._1)(y._1); }
        return false;
      }
      if (x.tag === "Right") {
        if (y.tag === "Right") { return dictEq1.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  }
);
const encodeResult = dictEncode => dictEncode1 => (
  {
    encode: v => {
      if (v.tag === "Left") { return {Left: dictEncode.encode(v._1)}; }
      if (v.tag === "Right") { return {Right: dictEncode1.encode(v._1)}; }
      $runtime.fail();
    }
  }
);
const decodeResult = dictDecode => dictDecode1 => (
  {
    decode: f => Control$dMonad$dExcept$dTrans.altExceptT(Data$dList$dTypes.semigroupNonEmptyList)(Data$dIdentity.monadIdentity).alt((() => {
      const $0 = Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign$dIndex.unsafeReadProp(Data$dIdentity.monadIdentity)("Left")(f))(value => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind((() => {
        const $0 = Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity);
        const $1 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
          Foreign.$ForeignError("ForeignError", "required key not found: Left"),
          Data$dList$dTypes.Nil
        ));
        if (Foreign.isUndefined(value)) { return $1; }
        return $0.pure();
      })())(() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(value))))(dictDecode.decode);
      if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
      if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dEither.$Either("Left", $0._1)); }
      $runtime.fail();
    })())((() => {
      const $0 = Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign$dIndex.unsafeReadProp(Data$dIdentity.monadIdentity)("Right")(f))(value => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind((() => {
        const $0 = Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity);
        const $1 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
          Foreign.$ForeignError("ForeignError", "required key not found: Right"),
          Data$dList$dTypes.Nil
        ));
        if (Foreign.isUndefined(value)) { return $1; }
        return $0.pure();
      })())(() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(value))))(dictDecode1.decode);
      if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
      if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dEither.$Either("Right", $0._1)); }
      $runtime.fail();
    })())
  }
);
export {Result, decodeResult, encodeResult, eqResult, fromEither, functorResult, newtypeResult, showResult, toEither, udecodeResult};
